// extracted by mini-css-extract-plugin
export default {"invalid-error":"LohForm_invalid-error__nrya-","submitBtn":"LohForm_submitBtn__l5SGu"};